export default __webpack_public_path__ + "static/media/busim-plansh3.983ffc6e.svg";